import { WhichElement, HCreateForm, HUseForm } from './index-components'

const components = [
  HCreateForm,
  HUseForm,
  WhichElement
]

export default {
  install(Vue) {
    components.forEach(component => {
      Vue.component(component.name, component)
    })
  }
}
